<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "auth-wrapper auth-v2" },
    [
      _c(
        "b-row",
        { staticClass: "auth-inner m-0" },
        [
          _c(
            "b-col",
            {
              staticClass:
                "d-flex align-items-center justify-content-center auth-bg p-3",
              attrs: { lg: "5" },
            },
            [
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center li-marker mb-3",
                  },
                  [
                    _c(
                      "h2",
                      { staticClass: "brand-text text-primary" },
                      [_c("Logo", { staticClass: "pike-brand-logo" })],
                      1
                    ),
                    _c("locale"),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "min-w-i" },
                  [
                    _c(
                      "b-card-title",
                      {
                        staticClass: "font-weight-bold mb-1",
                        attrs: { "title-tag": "h2" },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("login.welcome")) + " ")]
                    ),
                    _c("validation-observer", {
                      ref: "loginValidation",
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            return [
                              _c(
                                "b-form",
                                {
                                  staticClass: "auth-login-form mt-2",
                                  on: {
                                    submit: function ($event) {
                                      $event.preventDefault()
                                      return _vm.validationForm($event)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t("login.email"),
                                        "label-for": "login-email",
                                      },
                                    },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t("login.email"),
                                          rules: "required|email",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      id: "login-email",
                                                      state:
                                                        errors.length > 0
                                                          ? false
                                                          : null,
                                                      name: _vm.$t(
                                                        "login.email"
                                                      ),
                                                      placeholder: _vm.$t(
                                                        "login.emailPlaceholder"
                                                      ),
                                                      autocomplete: "off",
                                                    },
                                                    model: {
                                                      value: _vm.userEmail,
                                                      callback: function ($$v) {
                                                        _vm.userEmail = $$v
                                                      },
                                                      expression: "userEmail",
                                                    },
                                                  }),
                                                  _c("Errors", {
                                                    attrs: { error: errors[0] },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-between",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              attrs: { for: "login-password" },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("login.password"))
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "b-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: "auth-forgot",
                                                  params: {
                                                    lang: _vm.lang || undefined,
                                                  },
                                                },
                                              },
                                            },
                                            [
                                              _c("small", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "login.forgotPassword"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t("login.password"),
                                          rules: "required",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "b-input-group",
                                                    {
                                                      staticClass:
                                                        "input-group-merge",
                                                      class:
                                                        errors.length > 0
                                                          ? "is-invalid"
                                                          : null,
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        staticClass:
                                                          "form-control-merge",
                                                        attrs: {
                                                          id: "login-password",
                                                          state:
                                                            errors.length > 0
                                                              ? false
                                                              : null,
                                                          type: _vm.passwordFieldType,
                                                          name: "login-password",
                                                          placeholder: _vm.$t(
                                                            "login.passwordPlaceholder"
                                                          ),
                                                          autocomplete: "off",
                                                        },
                                                        model: {
                                                          value: _vm.password,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.password = $$v
                                                          },
                                                          expression:
                                                            "password",
                                                        },
                                                      }),
                                                      _c(
                                                        "b-input-group-append",
                                                        {
                                                          attrs: {
                                                            "is-text": "",
                                                          },
                                                        },
                                                        [
                                                          _c("feather-icon", {
                                                            staticClass:
                                                              "cursor-pointer",
                                                            attrs: {
                                                              icon: _vm.passwordToggleIcon,
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.togglePasswordVisibility,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c("Errors", {
                                                    attrs: { error: errors[0] },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("ReCaptcha", {
                                    attrs: {
                                      verifyCaptcha: _vm.verifyCaptcha,
                                      captchaErr: _vm.captchaErr,
                                    },
                                  }),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mt-1",
                                      attrs: {
                                        type: "submit",
                                        variant: "primary",
                                        block: "",
                                        disabled: !_vm.status || _vm.isLoading,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("login.signInBtn")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c(
                      "b-card-text",
                      { staticClass: "text-center mt-2" },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("login.newPlatform"))),
                        ]),
                        _c(
                          "b-link",
                          {
                            attrs: {
                              to: {
                                name: "auth-register",
                                params: { lang: _vm.lang || undefined },
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                " " + _vm._s(_vm.$t("login.createAccount"))
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "auth-footer-btn d-flex justify-content-center",
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass:
                                "d-flex google-btn align-items-center",
                              attrs: { variant: "outline-secondary" },
                              on: { click: _vm.initiateGoogleSignIn },
                            },
                            [_c("GoogleImg")],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _c(
            "b-col",
            {
              staticClass: "d-none d-flex align-items-center auth-bg",
              attrs: { lg: "7" },
            },
            [_c("div", { staticClass: "responsive" }, [_c("SideImg2")], 1)]
          ),
        ],
        1
      ),
      _c("SecurityVerification", {
        attrs: {
          showVerificationPop: _vm.showVerificationPop,
          submitVerification: _vm.submitVerification,
          onModalHidden: _vm.onModalHidden,
          accessToken: _vm.accessToken,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/views/auth/Login.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as veevalidate from 'vee-validate';
import core_layouts_components_Logo_vue from '@core/layouts/components/Logo.vue';
import assets_images_pages_google_svg from '@/assets/images/pages/google.svg';
import assets_rashi_coin_apple_logo_svg from '@/assets/rashi-coin/apple-logo.svg';
import assets_images_pages_login_v2_svg from '@/assets/images/pages/login-v2.svg';
import views_auth_ReCaptcha_vue from '@/views/auth/ReCaptcha.vue';
import layouts_components_Locale_vue from '@/layouts/components/Locale.vue';
import layouts_components_SecurityVerification_vue from '@/layouts/components/SecurityVerification.vue';
import layouts_components_Errors_vue from '@/layouts/components/Errors.vue';
import assets_rashi_coin_logo_svg from '@/assets/rashi-coin/logo.svg';
import * as bootstrapvue from 'bootstrap-vue';
import validations from '@validations';
import core_mixins_ui_forms from '@core/mixins/ui/forms';
import store_index from '@/store/index';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import * as vuerecaptcha from 'vue-recaptcha';
import libs_api_api from '@/libs/api/api';
import auth_jwt_useJwt from '@/auth/jwt/useJwt';
import * as vuex from 'vuex';
import EventBus from '@/EventBus';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable global-require */




















export default ({
  render,
  staticRenderFns,
  components: {
    BRow: bootstrapvue["BRow"],
    BCol: bootstrapvue["BCol"],
    BLink: bootstrapvue["BLink"],
    BFormGroup: bootstrapvue["BFormGroup"],
    BFormInput: bootstrapvue["BFormInput"],
    BInputGroupAppend: bootstrapvue["BInputGroupAppend"],
    BInputGroup: bootstrapvue["BInputGroup"],
    BFormCheckbox: bootstrapvue["BFormCheckbox"],
    BCardText: bootstrapvue["BCardText"],
    BCardTitle: bootstrapvue["BCardTitle"],
    BImg: bootstrapvue["BImg"],
    BForm: bootstrapvue["BForm"],
    BButton: bootstrapvue["BButton"],
    VuexyLogo: core_layouts_components_Logo_vue,
    ValidationProvider: veevalidate["ValidationProvider"],
    ValidationObserver: veevalidate["ValidationObserver"],
    VueRecaptcha: vuerecaptcha["VueRecaptcha"],
    GoogleImg: assets_images_pages_google_svg,
    SideImg2: assets_images_pages_login_v2_svg,
    AppleImg: assets_rashi_coin_apple_logo_svg,
    ReCaptcha: views_auth_ReCaptcha_vue,
    Locale: layouts_components_Locale_vue,
    SecurityVerification: layouts_components_SecurityVerification_vue,
    Errors: layouts_components_Errors_vue,
    Logo: assets_rashi_coin_logo_svg
  },
  mixins: [core_mixins_ui_forms["togglePasswordVisibility"]],
  data() {
    return {
      password: "",
      userEmail: "",
      required: validations["required"],
      email: validations["email"],
      isLoading: false,
      sideImg: require("@/assets/images/pages/forgot-password-v2.svg"),
      status: false,
      captchaErr: "",
      captchaResponse: "",
      showVerificationPop: false,
      response: null,
      lang: this.$route.params.lang,
      accessToken: ""
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store_index.state.appConfig.layout.skin === "dark") {
        this.sideImg = require("@/assets/images/pages/login-v2-dark.svg");
        return this.sideImg;
      }
      return this.sideImg;
    }
  },
  methods: {
    ...vuex.mapMutations("user", ["setUser"]),
    verifyCaptcha(status, captchaResponse) {
      this.status = status;
      this.captchaResponse = captchaResponse;
    },
    onModalHidden() {
      this.showVerificationPop = false;
      EventBus.$emit("reset_captcha");
    },
    async submitVerification(code) {
      {
        try {
          const res = await new libs_api_api().api({
            method: "post",
            url: "auth/verifyOTP"
          }, {
            code
          }, {
            isLoading: true,
            http_headers: {
              authorization: `Bearer ${this.accessToken || (this.response && (this.response.accessToken || (this.response.token && this.response.token.accessToken)))}`
            }
          });
          if (res && res.result && res.result.requestStatus === "SUCCESS") {
            this.onModalHidden();
            if (this.response) {
              var _subTok = this.accessToken || (this.response && (this.response.accessToken || (this.response.token && this.response.token.accessToken))); var _subRefTok = this.response && (this.response.refreshToken || (this.response.token && this.response.token.refreshToken)); if (_subTok) { localStorage.setItem(auth_jwt_useJwt.jwtConfig.storageTokenKeyName, _subTok); } if (_subRefTok) { localStorage.setItem(auth_jwt_useJwt.jwtConfig.storageRefreshTokenKeyName, _subRefTok); }
              if (this.response.userInfo) {
                this.setUser(this.response.userInfo);
                localStorage.setItem("userInfo", JSON.stringify(this.response.userInfo));
              }
              this.$router.push({
                name: "home",
                params: {
                  lang: this.lang || undefined
                }
              });
            }
          } else if (res && res.error && res.error.message) {
            this.$toast({
              component: core_components_toastification_ToastificationContent_vue,
              props: {
                title: res.error.message,
                icon: "EditIcon",
                variant: "danger"
              }
            });
          }
        } catch (error) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: error,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
        this.isLoading = false;
      }
    },
    validationForm() {
      const me = this;
      this.$refs.loginValidation.validate().then(success => {
        if (success) {
          if (me.status) {
            me.captchaErr = "";
            me.login();
          } else {
            me.captchaErr = "Captcha check required";
          }
        }
      });
    },
    async login() {
      try {
        this.isLoading = true;
        const res = await new libs_api_api().api({
          method: "post",
          url: "auth/login"
        }, {
          email: this.userEmail,
          password: this.password,
          captchaResponse: this.captchaResponse
        }, {
          isLoading: true
        });
        EventBus.$emit("reset_captcha");
        var _accTok = res && (res.accessToken || (res.token && res.token.accessToken));
        var _refTok = res && (res.refreshToken || (res.token && res.token.refreshToken));
        if (_accTok) {
          if (res.userInfo && res.userInfo.totpLinked) {
            this.showVerificationPop = true;
            this.response = res;
            this.accessToken = _accTok;
          } else {
            localStorage.setItem(auth_jwt_useJwt.jwtConfig.storageTokenKeyName, _accTok);
            if (_refTok) {
              localStorage.setItem(auth_jwt_useJwt.jwtConfig.storageRefreshTokenKeyName, _refTok);
            }
            if (res.userInfo) {
              this.setUser(res.userInfo);
              localStorage.setItem("userInfo", JSON.stringify(res.userInfo));
            }
            this.$router.push({
              name: "home",
              params: {
                lang: this.lang || undefined
              }
            });
          }
        } else if (res && res.error && res.error.message) {
          this.response = null;
          this.accessToken = "";
          // EventBus.$emit("reset_captcha");
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    },
    async initiateGoogleSignIn() {
      try {
        const res = await new libs_api_api().api({
          method: "post",
          url: "auth/google/login/init"
        });
        if (res && res.result && res.result.requestStatus === "SUCCESS") {
          const googleSignInUrl = res.redirectUrl;
          window.location.href = googleSignInUrl;
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    },
    async initiateAppleSignIn() {
      try {
        const res = await new libs_api_api().api({
          method: "post",
          url: "auth/apple/login/init"
        });
        if (res && res.result && res.result.requestStatus === "SUCCESS") {
          const appleSignInUrl = res.redirectUrl;
          window.location.href = appleSignInUrl;
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    }
  }
});

//# sourceURL=webpack:///./src/views/auth/Login.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style>
.auth-wrapper {
  display: flex;
  flex-basis: 100%;
  min-height: 100vh;
  min-height: calc(var(--vh, 1vh) * 100);
  width: 100%;
}
.auth-wrapper .auth-inner {
  width: 100%;
  position: relative;
}
.auth-wrapper.auth-v1 {
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.auth-wrapper.auth-v1 .auth-inner:before {
  width: 244px;
  height: 243px;
  content: " ";
  position: absolute;
  top: -54px;
}
[dir] .auth-wrapper.auth-v1 .auth-inner:before {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPQAAADzCAMAAACG9Mt0AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAA9KADAAQAAAABAAAA8wAAAADhQHfUAAAAyVBMVEUAAAD///+AgP+AgP9mZv+AgNWAgP9tbf9gYP+AgP9xcf9mZv+AZuaAgP9dXf90dOhiYv92dv9mZu5mZv93d+53d/9paf94afCAcfFrXvJra/9mZvJzZvJzc/JoaP96b/Rqav91aupsYvV2bOt2bPVxaPZ7cfZqavZyau1waPd4aO9xafBxafh4afB1bfh4avFuZ/F2afJzZvJzZ/N0aPN0bvN3bPR0ae5yZ/R3be93bfR1au9zafBxbPVzavV0a/F0a/ZyafFwaPKZm3nTAAAAQ3RSTlMAAQIEBQYGBwgICQoKCgsLDQ0PDw8PERESExMUFBQWFxgYGhoaGxsdHSAgIiIiIyQlJygqLCwtLi8vLzAzNDU3Nzg7h9vbHgAAA9RJREFUeNrt3ftS2kAUx/Fc1gSyWsErtuJdRDQiiteolb7/QzUoTm07k4AzObuu3/MCez45yWbzT36eZ6b8erO1e1B97baadd+zocJWmg0HaXe/+uqmg2GWtkLT5Lle1m9LdhG2+1lvzuiUO1knEF81yFc1N+35m15kZOGodz1vyLx+v2Lseq/erxtZd/NuweCTtfiwaWLOD5FnsqI7+VnP3y8afnEs3Es/1+H1qvETwuq18B7e6VlwLup1ZM8kWWQBOsrmHL7GVtxvYRZYgQ4ywae61ffsqH5Lbq20bQm6ncp9P2ehJegwE/u+rl95ttSwLrVSc2ANetAU28dSa9Cp2E623bUG3d2VWmn/wBq0XCugQYMGLdVKoOJaoiuok1NdXSW1WAUfRPtRUllflaJf5ZE/O9pXVbZUPTov5c+IDqvtRwStdTgLutoxy6GnGfYb2o+1I2gd+1OiqzfLocvVE7TSDqG1mgodaqfQZbvZC9rXjqG1X45WzqFVKVpk0LLo4lGP0ZGD6KgMnTiITkrQgXYQrYNitHISrYrRsZPouBhdcxJdK0YnTqKTYrR2Eq1BgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRoh9DH59ag86ACoSYOL61B55EUQk1s3VqDzsNHhJpYe7QGncfMSHUxaliCHgcKSXVxeWQJehwdJdXF4dAS9DgkTKqLxuibFeiXODixNi7OrEC/BP+JtbE0WrYA/RrxKNfH2YUF6NegSbk+Gk87xtErN6EsWm88fzeMXpwE9EruLns/l42io4dJFLPo2/Po1w+D6IW7t9Bt2SPx3vOOMfS7eHVZtN54ulg2go56138Ct4XRunE2Ovsmjg46WeddUoUWr6WL0fCoIYgO2/2s91fstDZQjcPL0ePt5flpdXUwqW46uMrS1j95JNpQrW0dHp9UV/uT2m416/8HVGg3qzhpBjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KC/FDpx0pwUo2tOomvF6NhJdFyMVk6iVTE6cBIdeF9vJyvZx/I/AzuIjsrQvoNovwzt4FamSs0Ojrp80PmvoB0zh940pb7azf1yg7t0LIt978uppzbnalfucDW92ZndLPRmKweGPduYJ+zoM5/Dk+gD5NdvLhXXPp88qcUqmEH5G5JZRs6cuxwIAAAAAElFTkSuQmCC");
}
[dir=ltr] .auth-wrapper.auth-v1 .auth-inner:before {
  left: -46px;
}
[dir=rtl] .auth-wrapper.auth-v1 .auth-inner:before {
  right: -46px;
}
@media (max-width: 575.98px) {
.auth-wrapper.auth-v1 .auth-inner:before {
    display: none;
}
}
.auth-wrapper.auth-v1 .auth-inner:after {
  width: 272px;
  height: 272px;
  content: " ";
  position: absolute;
  bottom: -55px;
  z-index: -1;
}
[dir] .auth-wrapper.auth-v1 .auth-inner:after {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARAAAAEQCAMAAABP1NsnAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAABEKADAAQAAAABAAABEAAAAAAQWxS2AAAAwFBMVEUAAAD///+AgICAgP9VVaqqVf+qqv+AgL+AgP9mZsxmZv+ZZv+AgNWAgP9tbdttbf+Sbf+AYN+AgN+AgP9xceNmZv+AZuaAZv90dOh0dP9qav+AauqAav+AgP92dv9tbf+Abe2Abf93Zu53d+6AcO94afCAcfF5a+R5a/JzZuaAZvKAc/J5bed5bfOAaPN6b/R1auqAavR6ZvV6cPV2bOuAbPV7aPZ2be2AbfZ7au17avZ3Zu53b+57a+97a/d4aO9J6CoeAAAAQHRSTlMAAQICAwMDBAQFBQUGBgcHBwgICAkKCgoLCwwMDAwNDg4ODw8QERITExQUFBUVFhcYGBkZGhobHBwdHR4eHx8gJ5uMWwAAA/FJREFUeNrt2G1XEkEYxvHZNk2xHGzdbKFl0cTwgdSkCKzu7/+t4pw6sAjtjIueE/f8r3fMO35nZnbuy5gVGcvfzJe0rnTfGI+MggGJRUZnbpPIhJKt88nU53JnFULvyISY6KAv8vPj0vr2rYwiE2Z2B9J+uNYcyyQxwWZvaeGH3G4bMjsvI/kcwTC/V+7kLoahlITzQojP3ZFgsJCh7IJQzpX0QFj4uMiY18eDMZ9bZCF9OQahnK6cm/Y7js0sh/LF3Auv1PlQd3MxbdXYIQspV44EEEAAAWTNDAYYkKdJbNMsLzYueZbaZ2iM46RVbHBaiZ9Js+nHEdli42N9XuSen5hGp1CQTuOJQDRsD99N4gMSpYWapNH6IJo83CIeILZQFesEaber79NCWRoukOpNEnW0gXQqD81w6ACxhbrYde7VuFCYeA2QRCNIsgZISyNIqz6IyhPjOjNVIFYniK3dmKU6QdLaJUimEySrDZLrBMlrgxRKU7sxCw/EMe0CAggggADySJCqxixIkKpNEh6IozELD8RxjQACCCCAAPJIkKrGLEgQXqqAAEJjxrQLCCCAAEJjRmNGY8a0CwgggABCYwYIfQgggNCYMe0CAggggNCY0ZjRmDHtAgIIIIAAQmNGHwIIIDRmTLuAAAIIIDRmNGY0Zky7gAACCCCA0JjRhwACCI0Z0y4ggAACCI0ZjRmNGdMuIIAAAgggNGb0IYAAQmPGtAsIIIAAQmNGY0ZjxrQLCCCAAAIIjRl9CCCA0Jgx7QICCCCA0JjRmNGYMe0CAggggABCY0YfAgggNGZMu4AAAgggNGY0ZjRmTLuAAAIIIIDQmNGHAAIIjRnTLiCAAAIIjRmNGY0ZIEy7gAACCCA0ZvQhgABCY8a0CwgggABCY0ZjBgiNGdMuIIAAAgiN2f/Sh+Q6PfLaIJlOkKw2SKoTJK3dmFmdILb2tBvrBIlrg5iWRo+WqQ+SaARJ1gCJAzsxThCN16p1vNurGjNjoo42j07kAHFskoY2kEbl33U0ZgoPjXW+Rl0gkarnahqtDaJKxMPDDWIiNafGenh4gExvVhXfmk7Da6L1AVGxSby2h6MxK79Zk42ea1pJbJ48sU2zDezQ8iy1z6BBwoyjMQsvXp8YQAAhgADilRfyy+wf8WqZZUfGZihvgZiB3FybC+kCUU5XLkAo50C+gbBQdUzkAIVyejIAYfFTI1solHP2HgNCnHn5AYNy4jvpoVB6fVzL91cwzLJ9Lfd7S0jhehxO5H5/yePr1W6gHonI7fJ5ORSR/n6Q2yQanq763zuXU5LJZRKiyD/W9/pjkdPZz0/yJ8fqVyry+qQZDMjJKoDfy8bRVhHhQTwAAAAASUVORK5CYII=");
}
[dir=ltr] .auth-wrapper.auth-v1 .auth-inner:after {
  right: -75px;
}
[dir=rtl] .auth-wrapper.auth-v1 .auth-inner:after {
  left: -75px;
}
@media (max-width: 575.98px) {
.auth-wrapper.auth-v1 .auth-inner:after {
    display: none;
}
}
.auth-wrapper.auth-v2 {
  align-items: flex-start;
}
.auth-wrapper.auth-v2 .auth-inner {
  height: 100vh;
  overflow-y: auto;
  height: calc(var(--vh, 1vh) * 100);
}
.auth-wrapper.auth-v2 .brand-logo {
  position: absolute;
  top: 2rem;
  z-index: 1;
}
[dir] .auth-wrapper.auth-v2 .brand-logo {
  margin: 0;
}
[dir=ltr] .auth-wrapper.auth-v2 .brand-logo {
  left: 2rem;
}
[dir=rtl] .auth-wrapper.auth-v2 .brand-logo {
  right: 2rem;
}
.auth-wrapper.auth-v1 .auth-inner {
  max-width: 400px;
}
.auth-wrapper .brand-logo {
  display: flex;
  justify-content: center;
}
[dir] .auth-wrapper .brand-logo {
  margin: 1rem 0 2rem 0;
}
.auth-wrapper .brand-logo .brand-text {
  font-weight: 600;
}
[dir] .auth-wrapper .auth-footer-btn .btn {
  padding: 0.6rem !important;
}
[dir=ltr] .auth-wrapper .auth-footer-btn .btn:not(:last-child) {
  margin-right: 1rem;
}
[dir=rtl] .auth-wrapper .auth-footer-btn .btn:not(:last-child) {
  margin-left: 1rem;
}
@media (min-width: 1200px) {
.auth-wrapper.auth-v2 .auth-card {
    width: 400px;
}
}
[dir] .auth-wrapper .auth-bg {
  background-color: #fff;
}
[dir] .dark-layout .auth-wrapper .auth-bg {
  background-color: #283046;
}
html[dir=rtl] svg.feather {
  transform: rotate(180deg);
}

/* Set specific width and height for the reCAPTCHA container */
.google-btn {
  justify-content: center;
  width: 100%;
}
.google-btn p {
  color: #000000;
  font-weight: 400;
}
label {
  font-weight: bold !important;
  color: rgba(0, 0, 0, 0.5);
  font-size: 1rem;
  font-weight: 500 !important;
}
[dir] label {
  margin-bottom: 6px;
}
[dir=ltr] .text-margin {
  margin-left: 8px;
}
[dir=rtl] .text-margin {
  margin-right: 8px;
}
[dir] .btn-outline-secondary.google-btn {
  background-color: #f7f7f7;
}
</style>
